import { getDebugPanelEnv } from '@/features/debugPanel/client/getDebugPanelEnv';

import { getDefaultConfig } from '../getDefaultConfig';
import { type UiConfig } from '../uiConfigTypes';
import { uiDevConfig } from '../uiDev.config';
import { uiProdConfig } from '../uiProd.config';
import { uiStageConfig } from '../uiStage.config';

export function getUiConfig(): UiConfig {
  const env = getDebugPanelEnv();

  if (env) {
    let config: UiConfig;

    switch (env) {
      case 'production':
        config = uiProdConfig;
        break;
      case 'stage':
        config = uiStageConfig;
        break;
      case 'dev':
        config = uiDevConfig;
        break;
      default:
        config = getDefaultConfig();
        break;
    }

    // If debug panel env cookie exists, force stage callback
    return { ...config, callbackUrl: uiStageConfig.callbackUrl };
  }

  return getDefaultConfig();
}
